module.exports = __webpack_public_path__ + "img/icon.62e84a1d.png";